import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tabType: "",
  pageData: {},
  library: [],
  librayDetails: [],
  searchLibrary: "",
  countryLibraryFilter: "",
  languagelibraryFilter: "",
  sectorlibraryFilter: "",
  croplibraryFilter: "",
};

const libraryPageSlice = createSlice({
  name: "libraryDetailPage",
  initialState,
  reducers: {
    setLibraryDetail: (state, action) => {
      state.tabType = action?.payload?.tabType;
      state.pageData = action?.payload?.pageData;
    },
    setLibrary: (state, action) => {
      state.library = action.payload;
    },
    setLibraryPageDetails: (state, action) => {
      state.librayDetails = action.payload;
    },

    setSectorLibraryFilter: (state, action) => {
      state.sectorlibraryFilter = action.payload;
    },
  },
});
export const {
  setLibraryDetail,
  setLibrary,
  setLibraryPageDetails,

  setSectorLibraryFilter,
} = libraryPageSlice.actions;
export default libraryPageSlice.reducer;
